import React from 'react';
import { useTranslation } from 'react-i18next';
import './WorkflowIndicator.css';

const WorkflowIndicator = ({ workflow, compact = false }) => {
  const { t } = useTranslation();
  
  if (!workflow) return null;

  const getWorkflowIcon = (type) => {
    switch (type) {
      case 'user_journey': return '👤';
      case 'business_process': return '📋';
      case 'technical_flow': return '⚙️';
      case 'data_pipeline': return '🔄';
      case 'single_step': return '🎯';
      default: return '🔗';
    }
  };

  const getWorkflowColor = (type) => {
    switch (type) {
      case 'user_journey': return '#3b82f6';
      case 'business_process': return '#10b981';
      case 'technical_flow': return '#8b5cf6';
      case 'data_pipeline': return '#f59e0b';
      case 'single_step': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const workflowIcon = getWorkflowIcon(workflow.workflowType);
  const workflowColor = getWorkflowColor(workflow.workflowType);

  return (
    <div className="workflow-indicator">
      <div className="workflow-header" style={{ borderColor: workflowColor }}>
        <div 
          className="workflow-icon" 
          style={{ backgroundColor: workflowColor }}
          title={workflow.workflowType}
        >
          {workflowIcon}
        </div>
        <div className="workflow-info">
          <h4 className="workflow-name">{workflow.workflowName}</h4>
          <p className="workflow-description">{workflow.workflowDescription}</p>
        </div>
      </div>

      <div className="workflow-details">
        <div className="workflow-step">
          <span className="step-label">{t('workflowIndicator.step')}</span>
          <span className="step-number">{workflow.workflowStep}</span>
        </div>

        {workflow.workflowTags && workflow.workflowTags.length > 0 && (
          <div className="workflow-tags">
            {workflow.workflowTags.map((tag, index) => (
              <span key={index} className="workflow-tag" title={`Tag: ${tag}`}>
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkflowIndicator;
